import { BaseGQLService } from '../../../common/services/BaseGQLService';
import { IntegrationConnectionResultMapper } from '../../mappers/IntegrationConnectionResultMapper';
import { IntegrationConnectionResult } from '../../models/IntegrationConnectionResult';
import { CrowdStrikeMapper } from '../mappers/CrowdStrikeMapper';
import { CrowdStrike } from '../models/CrowdStrike';

export const UPDATE_CROWDSTRIKE_INTEGRATION = `
mutation ($baseUrl: String!, $clientId: String!, $clientSecret: String!) {
  updateCrowdStrikeIntegration(
    input: {baseUrl: $baseUrl, clientId: $clientId, clientSecret: $clientSecret}
  ) {
    crowdStrikeIntegration {
      baseUrl
      clientId
      clientSecret
    }
  }
}
`;
export const CHECK_CROWDSTRIKE_INTEGRATION = `
mutation ($baseUrl: String!, $clientId: String!, $clientSecret: String!) {
  checkCrowdStrikeIntegration(
    input: {baseUrl: $baseUrl, clientId: $clientId, clientSecret: $clientSecret}
  ) {
    crowdStrikeConnectionResult {
      isSuccessful
      reason
    }
  }
}
`;

export const UNLINK_CROWDSTRIKE_INTEGRATION = `
mutation {
  unlinkCrowdStrikeIntegration(input: {}) {
    __typename
  }
}
`;

export type CrowdStrikeIntegrationArgs = {
  baseUrl: string;
  clientId: string;
  clientSecret: string;
};

export type CheckCrowdStrikeIntegrationArgs = CrowdStrikeIntegrationArgs;

export class CrowdStrikeRepository extends BaseGQLService {
  private readonly connectionResultMapper = new IntegrationConnectionResultMapper();
  private readonly crowdStrikeMapper = new CrowdStrikeMapper();

  async checkIntegrationConnection(args: CheckCrowdStrikeIntegrationArgs): Promise<IntegrationConnectionResult> {
    return this.mutate(CHECK_CROWDSTRIKE_INTEGRATION, args, (data) =>
      this.connectionResultMapper.mapGQLModel(data.checkCrowdStrikeIntegration.crowdStrikeConnectionResult)
    );
  }

  async updateIntegration(args: CrowdStrikeIntegrationArgs): Promise<CrowdStrike> {
    return this.mutate(UPDATE_CROWDSTRIKE_INTEGRATION, args, (data) =>
      this.crowdStrikeMapper.mapGQLModel(data.updateCrowdStrikeIntegration.crowdStrikeIntegration)
    );
  }

  async unlinkIntegration(): Promise<void> {
    return this.mutate(UNLINK_CROWDSTRIKE_INTEGRATION, {});
  }
}
